module.exports = __webpack_public_path__ + "img/secure.223a8fc.png";